module.exports = __webpack_public_path__ + "static/assets/01e57fe722107cccae74e51b97e2d41f.gif";